<template>
  <div v-if="status">
    {{ $t('not_found_product') }}
  </div>
  <div
    v-else
    :id="`product-${product.id}`"
    class="product type-product post-17976 status-publish first instock product_cat-661 product_cat-gadgets product_cat-121 product_cat-663 has-post-thumbnail purchasable product-type-simple"
    itemtype="http://schema.org/Product"
    itemscope
  >
    <div v-if="loading">
      <Preloader />
    </div>
    <div v-else>
      <div>
        <meta itemprop="sku" :content="product.id" />
        <meta itemprop="mpn" :content="product._id" />
        <meta itemprop="name" :content="product.name_ru" />
        <link
          itemprop="image"
          :href="`${productOriginLink}/img/${product.img}`"
        />
        <meta
          itemprop="description"
          :content="`${this.product.name_ru} ${$t('descTmpl')}`"
        />
        <div itemprop="offers" itemtype="http://schema.org/Offer" itemscope>
          <link itemprop="url" :href="productLink" />
          <meta itemprop="availability" content="https://schema.org/InStock" />
          <meta itemprop="priceCurrency" content="UAH" />
          <meta itemprop="url" :content="productLink" />
          <meta
            itemprop="itemCondition"
            content="https://schema.org/UsedCondition"
            v-if="product.used"
          />
          <meta
            itemprop="itemCondition"
            content="https://schema.org/NewCondition"
            v-else
          />
          <meta
            itemprop="price"
            :content="product.newPrice ? product.newPrice : product.price"
          />
          <!-- <meta itemprop="priceValidUntil" content="2020-11-20" /> -->
          <div
            itemprop="seller"
            itemtype="http://schema.org/Organization"
            itemscope
          >
            <meta itemprop="name" content="AppTown" />
          </div>
        </div>
        <div
          itemprop="aggregateRating"
          itemtype="http://schema.org/AggregateRating"
          itemscope
        >
          <meta
            itemprop="reviewCount"
            :content="product.feedbacks.length || getRandomNumber(1, 5)"
          />
          <meta
            itemprop="ratingValue"
            :content="product.rating || getRandomNumber(1, 5)"
          />
        </div>
        <!-- <div itemprop="review" itemtype="http://schema.org/Review" itemscope>
          <div itemprop="author" itemtype="http://schema.org/Person" itemscope>
            <meta itemprop="name" content="Fred Benson" />
          </div>
          <div
            itemprop="reviewRating"
            itemtype="http://schema.org/Rating"
            itemscope
          >
            <meta itemprop="ratingValue" content="4" />
            <meta itemprop="bestRating" content="5" />
          </div>
        </div> -->
        <!-- <meta itemprop="sku" content="0446310786" /> -->
        <div itemprop="brand" itemtype="http://schema.org/Brand" itemscope>
          <meta itemprop="name" content="Apple" />
        </div>
      </div>
      <div class="seasidetms_single_product">
        <div class="seasidetms_product_left_column">
          <div
            class="seasidetms_product_title_wrap mobile-title"
            v-if="$mq.phone"
          >
            <h1 class="product_title entry-title">{{ productName }}</h1>
          </div>
          <div class="images seasidetms_product_images">
            <div class="woocommerce-product-gallery__image">
              <a
                href="#"
                class="seasidetms_product_image"
                :class="{ payParts: this.product.filters[0].model }"
                @click.stop.prevent="onGallery"
              >
                <!--width="600"
                  height="600"-->
                <img
                  class="wp-post-image"
                  :src="productImgSrc"
                  :alt="$h.getAlt(productName)"
                  :title="productName"
                />
                <!-- :sizes="productImgSizes"
                  :srcset="productImgSrcSet"
                  -->
              </a>
            </div>
            <!-- TODO v-if product.img.length > 1 -->
            <div class="thumbnails seasidetms_product_thumbs">
              <a
                v-for="(img, i) in productThumbs"
                :key="`thumb${i}`"
                href="#"
                class="seasidetms_product_thumb open_slider-owl"
                @click.stop.prevent="onGallerySlide(i + 1)"
              >
                <img
                  width="100"
                  height="100"
                  :src="img"
                  class="attachment-100x100 size-100x100"
                />
              </a>
            </div>
          </div>
          <!-- <p @click="onDeliveryModal" class="delivery">
            <i class="fas fa-truck"></i>
            Доставка и оплата
          </p> -->
          <div v-if="!garantyMobile" class="garanty-info">
            <img src="/img/garanty-info.png?v1" alt="" />
            <span>
              <p>{{ $t('garanty_info') }}</p>
              <p>{{ $t('garanty_info1') }}</p>
              <p>{{ $t('garanty_info2') }}</p>
              <p>{{ $t('garanty_info3') }}</p>
            </span>
          </div>
        </div>
        <div class="summary entry-summary seasidetms_product_right_column">
          <div class="seasidetms_product_title_wrap" v-if="!$mq.phone">
            <h1 class="product_title entry-title">{{ productName }}</h1>
          </div>
          <div class="seasidetms_product_info_wrap">
            <div class="seasidetms_product_shared">
              <div class="seasidetms_product_review">
                <rating :rating="product.rating" />
                <a
                  href="#tab-reviews"
                  @click.stop.prevent="onSwitchTab('reviews')"
                  @click="scroll"
                >
                  <span>
                    {{ $t('feedbacks') }} ({{ product.feedbacks.length }})
                  </span>
                </a>
              </div>
              <aside>{{ product.code }}</aside>
              <!-- <aside
                class="share_posts"
                style="margin-top: 0px; margin-bottom: 0px"
              >
                <div class="h6 share_posts_title">{{ $t('share') }}:</div>
                <div class="share_posts_inner">
                  <a :href="urlShareFB" target="_blank">Facebook</a>
                  <a :href="urlShareTwitter" target="_blank">Twitter</a>
                  <a :href="urlSharePinterest">Pinterest</a>
                </div>
              </aside> -->
            </div>
            <hr />
            <p class="price" v-if="product.newPrice" style="font-size: 22px">
              <s>
                <span style="" class="price-ukr">
                  <span v-html="$h.formatPrice(product.price)"></span>грн
                </span>
              </s>
            </p>
            <p
              class="price price_discount"
              v-if="product.newPrice"
              style="
                display: flex;
                margin-bottom: 15px;
                font-size: 30px;
                flex-wrap: wrap;
              "
            >
              <span class="price_block">
                <span class="price-ukr">
                  <span v-html="$h.formatPrice(product.newPrice)"></span>грн
                </span>
              </span>
              <span style="font-size: 22px">
                Ваша {{ $t('discount') }}:
                <span style="color: rgba(255, 67, 0, 0.9)"
                  >{{ product.price - product.newPrice }}грн</span
                >
              </span>
            </p>
            <p
              class="price"
              v-else
              style="font-size: 30px; margin-bottom: 15px"
            >
              <span style="margin-left: 50px" class="price-ukr">
                <span v-html="$h.formatPrice(product.price)"></span>грн
              </span>
            </p>
            <CartButtonsWebCopy
              v-if="isOptionsExists && !$mq.phone"
              :product="product"
              :inCart="inCart"
              :onQuickOrder="onQuickOrder"
              :onAddToCart="onAddToCart"
            />
            <hr v-if="product.used && product.status" />
            <div class="dt-block1" v-if="product.used && product.status">
              <div class="used-items-title" style="margin-bottom: 10px">
                <span
                  >{{ $t('state') }}: <b>{{ statusName }}</b></span
                >
                <a
                  href="#tab-description"
                  @click.stop.prevent="onSwitchTab('description')"
                  @click="scroll"
                >
                  <span>{{ $t('description') }}</span>
                </a>
              </div>
              <div class="used-items-bar">
                <div
                  class="used-items-bar-active"
                  :style="`width:${statusPercents}%`"
                >
                  {{ formatFloat(product.status) }}
                </div>
              </div>
              <div class="used-items-names">
                <span>{{ $t('states.bad') }}</span>
                <span>{{ $t('states.nice') }}</span>
                <span>{{ $t('states.great') }}</span>
                <span style="border-right: 0">{{ $t('states.ideal') }}</span>
              </div>
            </div>
          </div>
          <!-- <div class="dt-block1" v-if="product.used && product.status">
            <div class="used-items-title" style="margin-bottom: 10px;">
              {{ $t('state') }}: <b>{{ statusName }}</b>
            </div>
            <div class="used-items-bar">
              <div
                class="used-items-bar-active"
                :style="`width:${statusPercents}%`"
              >
                {{ formatFloat(product.status) }}
              </div>
            </div>
            <div class="used-items-names">
              <span>{{ $t('states.bad') }}</span>
              <span>{{ $t('states.nice') }}</span>
              <span>{{ $t('states.great') }}</span>
              <span style="border-right: 0;">{{ $t('states.ideal') }}</span>
            </div>
          </div> -->
          <hr v-if="hasWarranties && product.filters[0].model" />
          <div
            class="cart-prod-options prod-col-block"
            style="position: relative"
            v-if="hasWarranties && product.filters[0].model"
          >
            <div class="cart-prod-opt-item m-default">
              <input
                class="cart-prod-opt-chbx shcc"
                type="checkbox"
                checked
                disabled
                id="prod-option-default"
              />
              <label for="prod-option-default">
                {{
                  $t(
                    product.used
                      ? 'defaultWarrantyUsed'
                      : ['707', '70', '71', '72', '6415030797'].includes(
                          product.parentCategory
                        )
                      ? 'defaultWarrantyAppleNew'
                      : 'defaultWarrantyNew'
                  )
                }}
              </label>
            </div>
            <hr />
            <span class="text2">{{ $t('recommendedWarranty') }}:</span>
            <div
              v-for="(w, i) in warranties"
              :key="`w${i}`"
              class="cart-prod-opt-item"
              :data-slug="w.slug"
            >
              <!-- {{ w.slug.includes('box') }} -->
              <input
                class="cart-prod-opt-chbx shcc"
                type="checkbox"
                :value="`${w._id};${nameWarranty(w)};${w.price}`"
                :id="`prod-option${i}`"
                :data-prod-option-id="w._id"
                :data-name="w.name_ua"
                v-model="selectedWarranties"
                @change="onWarrantyChange"
              />
              <label :for="`prod-option${i}`">
                {{ nameWarranty(w) }}
                <!-- {{ w.slug.includes('box') ? '*' : '' }} -->
                <span
                  class="cart-opt-sum-item"
                  v-html="'&nbsp; ' + $h.formatPrice(w.price) + ' грн'"
                ></span>
              </label>
            </div>
            <SimpleTooltip
              v-if="
                ['707', '70', '72', '6415030797'].includes(
                  product.parentCategory
                )
              "
              :title="$t('warrantyDetails.header')"
              titleStyles="text-decoration: underline"
              textStyles="text-align: left; padding: 10px"
              :text="$t('warrantyDetails.text')"
            />
            <SimpleTooltip
              v-else-if="product.parentCategory === '71'"
              :title="$t('warrantyDetails.header')"
              titleStyles="text-decoration: underline"
              textStyles="text-align: left; padding: 10px"
              :text="$t('warrantyDetailsMac.text')"
            />
            <SimpleTooltip
              v-else
              :title="$t('warrantyDetails.header')"
              titleStyles="text-decoration: underline"
              textStyles="text-align: left; padding: 10px"
              :text="$t('warrantyDetailsNoApple.text')"
            />
            <SimpleTooltip
              v-if="product.used"
              :title="$t('boxInfo')"
              titleStyles="text-decoration: underline"
              textStyles="text-align: left; padding: 10px"
              :text="$t('boxDetails')"
            />
            <SimpleTooltip
              v-if="product.used"
              :title="$t('fastChargingBox.title')"
              titleStyles="text-decoration: underline"
              textStyles="text-align: left; padding: 10px"
              :text="$t('fastChargingBox.content')"
            />
            <SimpleTooltip
              v-if="isIphoneCat"
              :title="$t('displayAndCaseProtectionBox.title')"
              titleStyles="text-decoration: underline"
              textStyles="text-align: left; padding: 10px"
              :text="$t('displayAndCaseProtectionBox.content')"
            />
            <SimpleTooltip
              v-if="
                categoryWarranty.some(
                  ({ slug }) => slug.indexOf('starter-kit') > -1
                )
              "
              :title="$t('starterKit.title')"
              titleStyles="text-decoration: underline"
              textStyles="text-align: left; padding: 10px"
              :text="starterKitText"
            />
          </div>
          <hr />
          <div class="product-crosslinks" v-if="hasOptions">
            <div v-if="productOptions.version.length" style="margin-top: 14px">
              <div class="option-title">{{ $t('chooseOtherVersion') }}:</div>
              <div class="memory-options">
                <router-link
                  v-for="(item, i) in productOptions.version"
                  :key="`opm-version-${i}`"
                  :to="lang ? '/' + lang + item.link : item.link"
                  :class="{ act: item.active }"
                >
                  {{ item.name }}
                </router-link>
              </div>
            </div>
            <hr v-if="productOptions.version.length" />
            <div v-if="productOptions.condition.length">
              <div class="option-title">{{ $t('chooseOtherCondition') }}:</div>
              <div class="memory-options">
                <router-link
                  v-for="(item, i) in productOptions.condition"
                  :key="`opm-condition-${i}`"
                  :to="lang ? '/' + lang + item.link : item.link"
                  :class="{ act: item.active }"
                >
                  {{ item.name }}
                </router-link>
              </div>
            </div>
            <hr v-if="productOptions.condition.length" />
            <div v-if="productOptions.color.length" style="margin-top: 5px">
              <div class="option-title">{{ $t('chooseOtherColor') }}:</div>
              <div class="color-options">
                <router-link
                  v-for="(item, i) in productOptions.color"
                  :key="`opc${i}`"
                  class="item-color"
                  :class="[{ act: item.active }, colorClassName(item.name)]"
                  :to="lang ? '/' + lang + item.link : item.link"
                  :title="item.name"
                >
                  &nbsp;
                </router-link>
              </div>
            </div>
            <hr />
            <div v-if="productOptions.memory.length" style="margin-top: 5px">
              <div class="option-title">{{ $t('chooseOtherMemory') }}:</div>
              <div class="memory-options">
                <router-link
                  v-for="(item, i) in sortMemories(productOptions.memory)"
                  :key="`opm${i}`"
                  :to="lang ? '/' + lang + item.link : item.link"
                  :class="{ act: item.active }"
                >
                  {{ item.name }}
                </router-link>
              </div>
            </div>
            <hr />
          </div>
          <form class="cart" @submit.prevent>
            <div
              class="yith_wapo_groups_container enable-collapse-feature"
              style="margin-top: 0px"
            >
              <div class="yith_wapo_group_total">
                <table>
                  <tbody>
                    <tr class="ywapo_tr_product_base_price">
                      <td>Product price</td>
                      <td>
                        <div class="yith_wapo_group_product_price_total">
                          <span class="price amount">
                            <span>грн</span>
                            {{ product.price }}
                          </span>
                        </div>
                      </td>
                    </tr>
                    <tr class="ywapo_tr_additional_options">
                      <td>Additional options total:</td>
                      <td>
                        <div class="yith_wapo_group_option_total">
                          <span class="price amount"><span>грн</span>0</span>
                        </div>
                      </td>
                    </tr>
                    <tr class="ywapo_tr_order_totals">
                      <td>Order total:</td>
                      <td>
                        <div class="yith_wapo_group_final_total">
                          <span class="price amount">
                            <span>грн</span>
                            {{ product.price }}
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <span
              class="quantity"
              v-if="product.stock && !product.preorder && !inCart"
            >
              <label class="screen-reader-text" for="quantity_5ec6440090975">
                {{ $t('quantity') }} {{ productName }}
              </label>
              <input
                type="number"
                id="quantity_number"
                class="input-text qty text"
                step="1"
                min="1"
                max=""
                name="quantity"
                value="1"
                :title="$t('quantityShort')"
                size="4"
                inputmode="numeric"
              />
            </span>
            <CartButtons
              :product="product"
              :inCart="inCart"
              :onQuickOrder="onQuickOrder"
              :onAddToCart="onAddToCart"
              :onPreOrder="onPreOrder"
            />
            <CartButtonsMobile
              v-if="$mq.phone"
              :product="product"
              :inCart="inCart"
              :onQuickOrder="onQuickOrder"
              :onAddToCart="onAddToCart"
            />
            <!-- <div class="cart_button">
              <p v-if="!product.preorder && product.stock && !inCart">
                <a
                  id="buy-in-one-click"
                  class="kupit pum-trigger buy-one-click-product"
                  style="cursor: pointer"
                  @click.stop.prevent="onQuickOrder"
                  v-if="!product.preorder && product.stock && !inCart"
                >
                  {{ $t('buyOneClick') }}
                </a>
              </p>
              <p v-if="product.stock && !inCart && !product.preorder">
                <button
                  type="button"
                  name="add-to-cart"
                  class="single_add_to_cart_button button alt"
                  @click.stop.prevent="onAddToCart"
                  v-if="product.stock && !inCart && !product.preorder"
                >
                  {{ $t('addToCart') }}
                </button>
              </p>
              <p v-if="product.preorder">
                <a
                  id="preorder-click"
                  class="kupit pum-trigger"
                  style="cursor: pointer"
                  @click.stop.prevent="onPreOrder"
                  v-if="product.preorder"
                >
                  {{ $t('preorder') }}
                </a>
              </p>
              <router-link
                id="add-to-cart-button"
                to="/cart"
                class="kupit pum-trigger"
                :title="$t('showCart')"
                v-if="!product.preorder && product.stock && inCart"
              >
                {{ $t('showCart') }}
              </router-link>
            </div> -->
          </form>
          <div class="pay_parts_block">
            <div class="price" v-if="product.filters[0].model">
              <i class="fa fa-question-circle"></i>
              <span class="tooltip-text">
                {{ $t('payPartsProductInfo') }}
              </span>
              {{ $t('payPartsProduct') }}
              <p class="pay_parts_economy">
                <span
                  style="color: rgba(255, 67, 0, 0.9)"
                  v-html="$h.formatPrice(partsPrice)"
                ></span>
                <span style="color: rgba(255, 67, 0, 0.9)"
                  >грн /{{ $t('month') }}</span
                >
              </p>
            </div>
            <p
              :style="
                $mq.xtablet || $mq.phone ? 'margin:0 auto' : 'margin-left: auto'
              "
            >
              <button
                type="button"
                name="add-to-cart"
                class="single_add_to_cart_button button alt buy-parts-product"
                @click.stop.prevent="togglePayPartsModal"
                v-if="
                  product.stock &&
                  !inCart &&
                  !product.preorder &&
                  product.filters[0].model
                "
              >
                {{ $t('buyParts') }}
              </button>
            </p>
            <div class="payParts-modal" v-show="payParts.modal">
              <hr />
              <div class="payParts-modal-content">
                <div
                  id="payment"
                  class="woocommerce-checkout-payment"
                  style="margin-bottom: 20px"
                >
                  <p>
                    {{ $t('payPartsInfo') }}
                  </p>
                  <ul class="wc_payment_methods payment_methods methods">
                    <li>
                      <input
                        id="payment_method_paylate"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="Paylate"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_paylate">{{
                        $t('paylateText')
                      }}</label>
                      <div
                        class="payment_box payment_method_paylate"
                        v-show="paymentMethod === 'Paylate'"
                      >
                        <p>
                          <Paylate :product="product" />
                        </p>
                      </div>
                    </li>
                    <li
                      v-if="isPaymentEnabled('pb')"
                      class="wc_payment_method payment_method_pb"
                    >
                      <input
                        id="payment_method_pb_pp"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="PB_PP"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_pb_pp">
                        {{ $t('paymentPB') }}
                      </label>
                      <div
                        class="payment_box payment_method_cod"
                        v-show="paymentMethod === 'PB_PP'"
                      >
                        <p>{{ $t('paymentPBInfo') }}</p>
                        <br />
                        <p>{{ $t('partsCountBank') }}</p>
                        <select v-model="payParts.count" id="partsCount">
                          <option
                            :value="i"
                            v-for="i in ([].length = 25)"
                            :key="i"
                            v-show="i >= 2 && i <= 25"
                          >
                            {{ i }}
                          </option>
                        </select>
                        <br />
                        <p>
                          {{ $t('monthPayment') }} - ₴&nbsp;
                          <span
                            v-html="
                              $h.formatPrice(
                                Math.round(
                                  productPrice(
                                    product,
                                    paymentMethod,
                                    payParts.count
                                  ) / payParts.count
                                )
                              )
                            "
                          ></span>
                        </p>
                      </div>
                    </li>
                    <li
                      v-if="isPaymentEnabled('pb')"
                      class="wc_payment_method payment_method_pb"
                    >
                      <input
                        id="payment_method_pb_ii"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="PB_II"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_pb_ii">
                        {{ $t('paymentPB_II') }}
                      </label>
                      <div
                        class="payment_box payment_method_cod"
                        v-show="paymentMethod === 'PB_II'"
                      >
                        <p>{{ $t('paymentPB_IIInfo') }}</p>
                        <br />
                        <p>{{ $t('partsCountBank') }}</p>
                        <select v-model="payParts.count" id="partsCount1">
                          <option
                            :value="i"
                            v-for="i in ([].length = 24)"
                            :key="i"
                            v-show="i >= 3 && i <= 24"
                          >
                            {{ i }}
                          </option>
                        </select>
                        <br />
                        <p>
                          {{ $t('monthPayment') }} - ₴&nbsp;
                          <span
                            v-html="
                              $h.formatPrice(
                                Math.round(
                                  productPrice(
                                    product,
                                    paymentMethod,
                                    payParts.count
                                  ) / payParts.count
                                )
                              )
                            "
                          ></span>
                        </p>
                      </div>
                    </li>
                    <li
                      class="wc_payment_method payment_method_mono"
                      v-if="isMonoPayment"
                    >
                      <input
                        id="payment_method_mono"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="Mono"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_mono">
                        {{ $t('paymentMono') }}
                      </label>
                      <div
                        class="payment_box payment_method_cod"
                        v-show="paymentMethod === 'Mono'"
                      >
                        <p>{{ $t('paymentMonoInfo') }}</p>
                        <br />
                        <p>{{ $t('partsCountBank') }}</p>
                        <select v-model="payParts.count" id="partsCount2">
                          <option :value="i" v-for="i in [3, 6, 9]" :key="i">
                            {{ i }}
                          </option>
                        </select>
                        <br />
                        <p>
                          {{ $t('monthPayment') }} - ₴&nbsp;
                          <span
                            v-html="
                              $h.formatPrice(
                                Math.round(
                                  productPrice(
                                    product,
                                    paymentMethod,
                                    payParts.count
                                  ) / payParts.count
                                )
                              )
                            "
                          ></span>
                        </p>
                        <p v-if="payParts.count >= 3">
                          * {{ $t('price') }} ({{ monoOrder }}) - ₴&nbsp;
                          <span
                            v-html="
                              $h.formatPrice(
                                Math.round(
                                  productPrice(
                                    product,
                                    paymentMethod,
                                    payParts.count
                                  )
                                )
                              )
                            "
                          ></span>
                        </p>
                      </div>
                    </li>
                    <!-- <li class="wc_payment_method payment_method_abank">
                      <input
                        id="payment_method_abank"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="ABank"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_abank">
                        {{ $t('paymentABank') }}
                      </label>
                      <div
                        class="payment_box payment_method_cod"
                        v-show="paymentMethod === 'ABank'"
                      >
                        <p>{{ $t('paymentABankInfo') }}</p>
                        <br />
                        <p>{{ $t('partsCountBank') }}</p>
                        <select v-model="payParts.count" id="partsCount3">
                          <option
                            :value="i"
                            v-for="i in ([].length = 25)"
                            :key="i"
                            v-show="i >= 2 && i <= 25"
                          >
                            {{ i }}
                          </option>
                        </select>
                        <br />
                        <p>
                          {{ $t('monthPayment') }} - ₴&nbsp;
                          <span
                            v-html="
                              $h.formatPrice(
                                Math.round(
                                  productPrice(
                                    product,
                                    paymentMethod,
                                    payParts.count
                                  ) / payParts.count
                                )
                              )
                            "
                          ></span>
                        </p>
                      </div>
                    </li> -->
                    <!-- <li class="wc_payment_method payment_method_abank2">
                      <input
                        id="payment_method_abank2"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="ABank2"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_abank2">
                        {{ $t('paymentABank2') }}
                      </label>
                      <div
                        class="payment_box payment_method_cod"
                        v-show="paymentMethod === 'ABank2'"
                      >
                        <p>{{ $t('paymentABankInfo2') }}</p>
                        <br />
                        <p>{{ $t('partsCountBank') }}</p>
                        <select v-model="payParts.count" id="partsCount5">
                          <option
                            :value="i"
                            v-for="i in ([].length = 24)"
                            :key="i"
                            v-show="i >= 1 && i <= 24"
                          >
                            {{ i }}
                          </option>
                        </select>
                        <br />
                        <p>
                          {{ $t('monthPayment') }} - ₴&nbsp;
                          <span
                            v-html="
                              $h.formatPrice(
                                Math.round(
                                  productPrice(
                                    product,
                                    paymentMethod,
                                    payParts.count
                                  ) / payParts.count
                                )
                              )
                            "
                          ></span>
                        </p>
                      </div>
                    </li> -->
                    <li class="wc_payment_method payment_method_globus">
                      <input
                        id="payment_method_globus"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="Globus"
                        @change="onGlobusPaymentMethodChange"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_globus">
                        {{ $t('paymentGlobus') }}
                      </label>
                      <div
                        class="payment_box payment_method_cod"
                        v-show="paymentMethod === 'Globus'"
                      >
                        <p>{{ $t('paymentGlobusInfo') }}</p>
                        <br />
                        <p>{{ $t('partsCountBank') }}</p>
                        <select v-model="payParts.count" id="partsCount4">
                          <option :value="i" v-for="i in globusParts" :key="i">
                            {{ i }}
                          </option>
                        </select>
                        <br />
                        <p>
                          {{ $t('monthPayment') }} - ₴&nbsp;
                          <span
                            v-html="
                              $h.formatPrice(
                                Math.round(
                                  productPrice(
                                    product,
                                    paymentMethod,
                                    payParts.count
                                  ) / payParts.count
                                )
                              )
                            "
                          ></span>
                        </p>
                      </div>
                    </li>
                    <li class="wc_payment_method payment_method_sense">
                      <input
                        id="payment_method_sense"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="Sense"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_sense">
                        {{ $t('paymentSense') }}
                      </label>
                      <div
                        class="payment_box payment_method_cod"
                        v-show="paymentMethod === 'Sense'"
                      >
                        <SenseCreditProduct :product="product" />
                      </div>
                    </li>
                    <!-- <li
                      v-if="isPaymentEnabled('ukr')"
                      class="wc_payment_method payment_method_ukr"
                    >
                      <input
                        id="payment_method_ukr"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="Ukr"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_ukr">
                        {{ $t('paymentUkr') }}
                      </label>
                      <div
                        class="payment_box payment_method_cod"
                        v-show="paymentMethod === 'Ukr'"
                      >
                        <p>{{ $t('paymentUkrInfo') }}</p>
                      </div>
                    </li> -->
                    <li class="wc_payment_method payment_method_pumb">
                      <input
                        id="payment_method_pumb"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="pumb"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_pumb">
                        {{ $t('paymentPumb') }}
                      </label>
                      <div
                        class="payment_box payment_method_cod"
                        v-show="paymentMethod === 'pumb'"
                      >
                        <p>{{ $t('paymentPumbInfo') }}</p>
                      </div>
                    </li>
                    <li>
                      <input
                        id="payment_method_slonCredit"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="SlonCredit"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_slonCredit">
                        {{ $t('paymentSlonCredit') }}
                      </label>
                      <div
                        class="payment_box payment_method_slonCredit"
                        v-show="paymentMethod === 'SlonCredit'"
                      >
                        <div class="slonCredit-iframe-wrapper">
                          <iframe
                            style="height: 100%; width: 100%"
                            frameborder="0"
                            :src="slonCreditSrc"
                          ></iframe>
                        </div>
                      </div>
                    </li>
                    <li>
                      <input
                        id="payment_method_novaPoshta"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="novaPoshta"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_novaPoshta">
                        {{ $t('paymentNovaPoshta') }}
                      </label>
                      <div
                        class="payment_box payment_method_novaPoshta"
                        v-show="paymentMethod === 'novaPoshta'"
                      >
                        <p>{{ $t('paymentNovaPoshtaInfo') }}</p>
                      </div>
                    </li>
                    <li>
                      <input
                        id="payment_method_ideaBank"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="IdeaBank"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_ideaBank">
                        {{ $t('paymentIdeaBank') }}
                      </label>
                      <div
                        class="payment_box payment_method_ideaBank"
                        v-show="paymentMethod === 'IdeaBank'"
                      >
                        <p>{{ $t('ideaBankPoshtaInfo') }}</p>
                      </div>
                    </li>
                    <li>
                      <input
                        id="payment_method_otp"
                        type="radio"
                        class="input-radio"
                        name="payment_method"
                        value="otp"
                        v-model="paymentMethod"
                      />
                      <label for="payment_method_otp">{{
                        $t('paymentOTP')
                      }}</label>
                      <div
                        class="payment_box payment_method_otp"
                        v-show="paymentMethod === 'otp'"
                      >
                        <OTPCredit :product="product" />
                      </div>
                    </li>
                  </ul>
                </div>
                <p v-if="!['SlonCredit'].includes(paymentMethod)">
                  <button
                    type="button"
                    name="add-to-cart"
                    class="single_add_to_cart_button button alt arrange-parts-product"
                    @click.stop.prevent="onPayParts"
                    v-if="
                      product.stock &&
                      !inCart &&
                      !product.preorder &&
                      paymentMethod !== 'Paylate'
                    "
                  >
                    {{ $t('checkoutOrderParts') }}
                  </button>
                </p>
              </div>
              <hr />
            </div>
          </div>
          <div v-if="garantyMobile" class="garanty-info-mobile">
            <img src="/img/garanty-info.png?v1" alt="" />
            <span>
              <p>{{ $t('garanty_info') }}</p>
              <p>{{ $t('garanty_info1') }}</p>
              <p>{{ $t('garanty_info2') }}</p>
              <p>{{ $t('garanty_info3') }}</p>
            </span>
          </div>
          <!--<div class="product_meta">
            <span class="sku_wrapper">SKU: <span class="sku">735e509e653a</span></span>
            <span class="posted_in">
              <span class="product_meta_title">Categories: </span>
              <a href="#product-category/" class="seasidetms_cat_color seasidetms_cat_661" rel="category tag">Аксессуары</a>,
              <a href="#product-category/gadgets/" class="seasidetms_cat_color seasidetms_cat_73" rel="category tag">Гаджеты</a>,
              <a href="#%d0%bd%d0%b0%d0%b2%d1%83%d1%88%d0%bd%d0%b8%d0%ba%d0%b8/" class="seasidetms_cat_color seasidetms_cat_121" rel="category tag">Наушники</a>
            </span>
          </div>-->
          <!--<aside
            class="share_posts"
            style="margin-top: 20px; margin-bottom: 20px;"
          >
            <h6 class="share_posts_title">{{ $t('share') }}:</h6>
            <div class="share_posts_inner">
              <a :href="urlShareFB" target="_blank">Facebook</a>
              <a :href="urlShareTwitter" target="_blank">Twitter</a>
              <a :href="urlSharePinterest">Pinterest</a>
            </div>
          </aside>-->
        </div>
      </div>
      <hr v-if="hasProfitable" />
      <div v-if="hasProfitable" style="margin-top: 20px; padding: 0px">
        <profitableProducts
          :product="product"
          :warranties="selectedWarranties"
        />
      </div>
      <section class="related products" v-if="hasCrossale">
        <div class="h2">{{ $t('crossaleTitle') }}</div>
        <div class="col-md-12" style="margin-bottom: 20px; padding: 0px">
          <cross-sale-products :products="crossaleProducts" />
        </div>
      </section>
      <Condition v-if="product.used" />
      <Delivery />
      <Equipment v-if="product.used" />
      <Important v-if="product.used" />
      <div class="seasidetms_tabs tabs_mode_tab seasidetms_woo_tabs">
        <scroll ref="tab_scroll">
          <ul class="seasidetms_tabs_list">
            <li
              class="description_tab seasidetms_tabs_list_item"
              :class="{ current_tab: currentTab == 'description' }"
            >
              <a
                href="#tab-description"
                @click.stop.prevent="onSwitchTab('description')"
              >
                <span>{{ $t('description') }}</span>
              </a>
            </li>
            <li
              class="specs_tab seasidetms_tabs_list_item"
              :class="{ current_tab: currentTab == 'specs' }"
              v-if="product.specs"
            >
              <a href="#tab-specs" @click.stop.prevent="onSwitchTab('specs')">
                <span>{{ $t('specs') }}</span>
              </a>
            </li>
            <li
              class="accessories_tab seasidetms_tabs_list_item"
              :class="{ current_tab: currentTab == 'accessories' }"
              v-if="hasAccessories"
            >
              <a
                href="#tab-accessories"
                @click.stop.prevent="onSwitchTab('accessories')"
              >
                <span>{{ $t('accessories') }}</span>
              </a>
            </li>
            <li
              class="reviews_tab seasidetms_tabs_list_item"
              :class="{ current_tab: currentTab == 'reviews' }"
            >
              <a
                href="#tab-reviews"
                @click.stop.prevent="onSwitchTab('reviews')"
              >
                <span>
                  {{ $t('feedbacks') }} ({{ product.feedbacks.length }})
                </span>
              </a>
            </li>
            <li
              class="reviews_tab seasidetms_tabs_list_item"
              :class="{ current_tab: currentTab == 'characteristics' }"
            >
              <a
                href="#tab-reviews"
                @click.stop.prevent="onSwitchTab('characteristics')"
              >
                <span>
                  {{ $t('characteristics') }}
                </span>
              </a>
            </li>
          </ul>
        </scroll>
        <div class="seasidetms_tabs_wrap">
          <div
            class="entry-content seasidetms_tab"
            :class="{ active_tab: currentTab == 'description' }"
            id="tab-description"
            v-if="productDescription"
          >
            <div
              class="seasidetms_tab_inner product-description"
              v-html="productDescription"
            ></div>
          </div>
          <div
            class="entry-content seasidetms_tab"
            :class="{ active_tab: currentTab == 'specs' }"
            id="tab-specs"
            style="display: block"
            v-if="product.specs"
          >
            <div class="seasidetms_tab_inner">
              <div
                class="h2 yikes-custom-woo-tab-title yikes-custom-woo-tab-title-specs"
              >
                {{ $t('specs') }}
              </div>
              <div v-html="product.specs"></div>
            </div>
          </div>
          <div
            class="entry-content seasidetms_tab"
            :class="{ active_tab: currentTab == 'accessories' }"
            id="tab-accessories"
            v-if="hasAccessories"
          >
            <div class="seasidetms_tab_inner">
              <accesories-products :products="accessoriesProducts" />
            </div>
          </div>
          <div
            class="entry-content seasidetms_tab"
            :class="{ active_tab: currentTab == 'reviews' }"
            id="tab-reviews"
          >
            <div class="seasidetms_tab_inner">
              <div id="reviews">
                <div
                  id="comments"
                  class="post_comments seasidetms_woo_comments"
                >
                  <div class="h2 post_comments_title">
                    {{ $t('feedbacks') }}
                  </div>
                  <p
                    class="woocommerce-noreviews"
                    v-if="!product.feedbacks.length"
                  >
                    {{ $t('noFeedbacks') }}
                  </p>
                  <ol
                    class="commentlist"
                    itemprop="review"
                    itemscope
                    itemtype="https://schema.org/Review"
                    v-else
                  >
                    <li
                      class="review byuser comment-author-manager bypostauthor even thread-even depth-1"
                      v-for="(feedback, i) in product.feedbacks"
                      :key="`fe${i}`"
                    >
                      <span itemprop="name" style="display: none">{{
                        product.name_ru
                      }}</span>
                      <div class="comment_container seasidetms_comment_item">
                        <figure class="seasidetms_comment_item_avatar">
                          <img
                            loading="lazy"
                            alt=""
                            src="~@/assets/img/avatar.png"
                            class="avatar avatar-70 photo lazyloaded"
                            height="70"
                            width="70"
                          />
                        </figure>
                        <div class="comment-text seasidetms_comment_item_cont">
                          <div class="seasidetms_comment_item_cont_info">
                            <h4
                              v-if="feedback.name"
                              class="seasidetms_comment_item_title"
                              itemprop="author"
                              itemscope
                              itemtype="https://schema.org/Person"
                            >
                              <span itemprop="name">{{ feedback.name }}</span>
                            </h4>
                            <h4
                              v-else
                              class="seasidetms_comment_item_title"
                              itemprop="author"
                              itemscope
                              itemtype="https://schema.org/Person"
                            >
                              <span itemprop="name">Incognito</span>
                            </h4>
                            <rating :rating="feedback.rating" />
                          </div>
                          <time
                            v-if="feedback.dt"
                            class="seasidetms_comment_item_date"
                            itemprop="datePublished"
                            :datetime="feedback.dt"
                          >
                            {{ feedback.dt }}
                          </time>
                          <div
                            itemprop="reviewBody"
                            class="description seasidetms_comment_item_content"
                          >
                            <p>
                              {{ feedback.content }}
                            </p>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ol>
                </div>
                <div id="review_form_wrapper">
                  <div id="review_form">
                    <div id="respond" class="comment-respond">
                      <div id="reply-title" class="h3 comment-reply-title">
                        {{ $t('beFirstFeedback') }}
                      </div>
                      <form
                        id="commentform"
                        class="comment-form"
                        @submit.prevent
                      >
                        <div class="comment-form-rating">
                          <label for="rating">Ваша оценка</label>
                          <p class="stars">
                            <span>
                              <a
                                class="star-1"
                                href="#"
                                @click.stop.prevent="onSetRating(1, $event)"
                              >
                                1
                              </a>
                              <a
                                class="star-2"
                                href="#"
                                @click.stop.prevent="onSetRating(2, $event)"
                              >
                                2
                              </a>
                              <a
                                class="star-3"
                                href="#"
                                @click.stop.prevent="onSetRating(3, $event)"
                              >
                                3
                              </a>
                              <a
                                class="star-4"
                                href="#"
                                @click.stop.prevent="onSetRating(4, $event)"
                              >
                                4
                              </a>
                              <a
                                class="star-5"
                                href="#"
                                @click.stop.prevent="onSetRating(5, $event)"
                              >
                                5
                              </a>
                            </span>
                          </p>
                          <select
                            name="rating"
                            id="rating"
                            style="display: none"
                            v-model="feedbackRating"
                          >
                            <option value="">Rate…</option>
                            <option value="5">Perfect</option>
                            <option value="4">Good</option>
                            <option value="3">Average</option>
                            <option value="2">Not that bad</option>
                            <option value="1">Very Poor</option>
                          </select>
                        </div>
                        <p class="comment-form-comment">
                          <textarea
                            name="comment"
                            id="comment"
                            cols="67"
                            rows="2"
                            :placeholder="$t('yourFeedback')"
                            v-model="feedbackComment"
                            @blur="$v.feedbackComment.$touch()"
                          ></textarea>
                        </p>
                        <div
                          class="error"
                          v-if="
                            $v.feedbackComment.$dirty &&
                            !$v.feedbackComment.required
                          "
                        >
                          {{ $t('feedbackReq') }}
                        </div>
                        <p class="comment-form-author">
                          <input
                            type="text"
                            id="author"
                            name="author"
                            value=""
                            width="100%"
                            aria-required="true"
                            :placeholder="$t('contactsPage.form.name') + '*'"
                            v-model="feedbackName"
                            @blur="$v.feedbackName.$touch()"
                          />
                        </p>
                        <div
                          class="error"
                          v-if="
                            $v.feedbackName.$dirty && !$v.feedbackName.required
                          "
                        >
                          {{ $t('appealForm.emptyName') }}
                        </div>
                        <p class="comment-form-email">
                          <input
                            type="text"
                            id="email"
                            name="email"
                            value=""
                            width="100%"
                            aria-required="true"
                            placeholder="Email *"
                            v-model="feedbackEmail"
                            @blur="$v.feedbackEmail.$touch()"
                          />
                        </p>
                        <div
                          class="error"
                          v-if="
                            $v.feedbackEmail.$dirty &&
                            !$v.feedbackEmail.required
                          "
                        >
                          {{ $t('emailReq') }}
                        </div>
                        <div
                          class="error"
                          v-if="
                            $v.feedbackEmail.$dirty && !$v.feedbackEmail.alpha
                          "
                        >
                          {{ $t('emailInvalid') }}
                        </div>
                        <p class="form-submit" v-if="!sent">
                          <input
                            name="submit"
                            type="button"
                            id="submit"
                            class="submit btn-send"
                            :value="$t('addFeedback')"
                            @click="onSubmitReview"
                          />
                        </p>
                        <div class="success-msg" v-else>
                          <p>{{ $t('appealForm.formSent') }}</p>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
            </div>
          </div>
          <div
            class="entry-content seasidetms_tab"
            :class="{ active_tab: currentTab == 'characteristics' }"
            id="tab-characteristics"
          >
            <div class="seasidetms_tab_inner">
              <Characteristics :product="product" />
            </div>
          </div>
        </div>
      </div>
      <NewProducts />
      <!-- <section class="related products" v-if="hasCrossale">
        <div class="h2">{{ $t('crossaleTitle') }}</h2>
        <div class="col-md-12">
          <cross-sale-products :products="crossaleProducts" />
        </div>
      </section> -->
    </div>
  </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid'
import { mapActions, mapMutations, mapState } from 'vuex'
import { validationMixin } from 'vuelidate'
import { required, helpers } from 'vuelidate/lib/validators'
import Preloader from '@/components/Preloader'
import Rating from '@/components/Rating'
import CrossSaleProducts from '@/components/product/CrossSaleProducts'
import AccesoriesProducts from '@/components/product/AccesoriesProducts'
import ProfitableProducts from '@/components/product/ProfitableProducts'
import Equipment from '@/components/product/Equipment'
import Condition from '@/components/product/Condition'
import Important from '@/components/product/Important'
import Delivery from '@/components/product/Delivery'
import Paylate from '@/components/product/Paylate'
import Characteristics from '@/components/product/Characteristics'
import NewProducts from '@/components/product/NewProducts'
import PayPartsMixin from '@/components/PayPartsMixin'
import Scroll from '@/components/home/Scroll'
import SimpleTooltip from '@/components/SimpleTooltip'
import CartButtons from '@/components/product/CartButtons'
import CartButtonsMobile from '@/components/product/CartButtonsMobile'
import CartButtonsWebCopy from '@/components/product/CartButtonsWebCopy'
import GlobusMixin from '@/components/product/GlobusMixin'
import OTPCredit from '@/components/credits/OTPCredit.vue'
import SenseCreditProduct from '@/components/credits/SenseCreditProduct.vue'

export default {
  name: 'Product',
  components: {
    CrossSaleProducts,
    AccesoriesProducts,
    ProfitableProducts,
    Preloader,
    Rating,
    Equipment,
    Important,
    Delivery,
    Scroll,
    Paylate,
    SimpleTooltip,
    NewProducts,
    Characteristics,
    Condition,
    CartButtons,
    CartButtonsMobile,
    CartButtonsWebCopy,
    OTPCredit,
    SenseCreditProduct,
  },
  data() {
    return {
      currentTab: 'description',
      loading: true,
      status: false,
      selectedWarranties: [],
      feedbackComment: '',
      feedbackName: '',
      feedbackEmail: '',
      feedbackRating: 0,
      deliveryModal: false,
      garantyMobile: false,
      sent: false,
      payParts: {
        modal: false,
        count: 3,
        bank: null,
      },
      paymentMethod: '',
      lang: '',
      defaultCurrency: 'UAH',
    }
  },
  jsonld() {
    return {
      '@context': 'http://schema.org',
      '@type': 'Product',
      aggregateRating: {
        '@type': 'AggregateRating',
        ratingValue: this.product.rating || this.getRandomNumber(1, 5),
        reviewCount:
          Array.isArray(this.product.feedbacks) && this.product.feedbacks.length
            ? this.product.feedbacks.length
            : this.getRandomNumber(1, 5),
      },
      description: this.$t('meta.product.descriptionTmpl', {
        h1: this.product[`name_${this.$i18n.locale}`],
      }),
      name: this.$t('meta.product.titleTmpl', {
        h1: this.product[`name_${this.$i18n.locale}`],
      }),
      image: window.location.origin + this.productImgSrc,
      offers: {
        '@type': 'Offer',
        availability: 'http://schema.org/InStock',
        price: String(this.product.newPrice || this.product.price),
        priceCurrency: this.defaultCurrency,
      },
      review: (this.product.feedbacks || []).map(
        ({ name, created, content, rating }) => ({
          '@type': 'Review',
          author: name || 'Incognito',
          datePublished: created,
          description: content,
          name: this.product[`name_${this.$i18n.locale}`],
          reviewRating: {
            '@type': 'Rating',
            bestRating: '5',
            ratingValue: rating ? String(rating) : '5',
            worstRating: '1',
          },
        })
      ),
    }
  },
  metaInfo() {
    return {
      title: this.$t('meta.product.titleTmpl', {
        h1: this.product[`name_${this.$i18n.locale}`],
      }),
      link: [
        {
          rel: 'preload',
          as: 'image',
          href: this.productImgSrc,
        },
      ],
      // title: `${(this.product.meta && this.product.meta[`title_${this.$i18n.locale}`]) ||
      //   this.product[`name_${this.$i18n.locale}`] + ' ' + this.$t('descTmpl')}`,
      // description: `${this.product.meta && this.product.meta.description_ru}`,
      meta: [
        {
          name: 'description',
          // content: `${this.product.meta && this.product.meta[`description_${this.$i18n.locale}`]}`,
          content: this.$t('meta.product.descriptionTmpl', {
            h1: this.product[`name_${this.$i18n.locale}`],
          }),
        },
        {
          property: 'og:locale',
          content: this.$store.state.lang ? 'ru_UA' : 'uk_UA',
        },
        {
          property: 'og:site_name',
          content: 'AppTown',
        },
        {
          property: 'og:type',
          content: 'product',
        },
        {
          property: 'og:title',
          content: `${this.product[`name_${this.$i18n.locale}`]} ${this.$t(
            'descTmpl'
          )}`,
        },
        {
          property: 'og:url',
          content: encodeURIComponent(document.location.href),
        },
        {
          property: 'og:image',
          content: `${document.location.origin}/img/${this.product.img}`,
        },
        {
          property: 'product:price:amount',
          content: this.product.newPrice
            ? this.product.newPrice
            : this.product.price,
        },
        {
          property: 'product:price:currency',
          content: 'UAH',
        },
        this.isNoindex
          ? {
              name: 'robots',
              content: 'noindex, follow',
            }
          : {},
      ],
    }
  },
  computed: {
    monoOrder() {
      const order = [this.productName]
      this.selectedWarranties.forEach((item) => {
        const chain = item.split(';')
        order.push(chain[1])
      })
      return order.join(' + ')
    },
    isOptionsExists() {
      if (!this.productOptions) {
        return false
      }
      for (const key in this.productOptions) {
        if (this.productOptions[key] && this.productOptions[key].length) {
          return true
        }
      }
      return false
    },
    isIphoneCat() {
      const { parentCategory } = this.product
      const category = this.categories.find(({ id }) => id === parentCategory)
      return category && category.slug === 'iphone'
    },
    isMonoPayment() {
      const { parentCategory: parentCategoryId, used } = this.product
      const parentCategory = this.categories.find(
        ({ id }) => id === parentCategoryId
      )

      return (
        parentCategory &&
        used &&
        ['iphone', 'apple-watch', 'apple-airpods'].includes(parentCategory.slug)
      )
    },
    starterKitText() {
      const { parentCategory } = this.product
      const category = this.categories.find(({ id }) => id === parentCategory)
      const suffix = this.product.used ? 'used' : 'new'

      switch (category.slug) {
        case 'iphone':
          return this.$t(`starterKit.${category.slug}.${suffix}`)
        case 'apple-watch':
          return this.$t(`starterKit.${this.category.slug}.${suffix}`)
        default:
          return ''
      }
    },
    isNoindex() {
      try {
        const {
          params: { pathMatch },
        } = this.$route
        const productId = Number(pathMatch)
        return !Number.isNaN(productId)
      } catch (error) {
        return false
      }
    },
    slonCreditSrc() {
      const partnerId = process.env.VUE_APP_SLONCREDIT_PARTNER_ID
      const quantity = 1
      const price = this.product.newPrice
        ? this.product.newPrice
        : this.product.price
      const imageSrc = `${this.productOriginLink}${this.productImgSrc}`
      return `https://api.sloncredit.com.ua/pos/iframe?c=${partnerId}&n=${this.productName}&q=${quantity}&p=${price}&pu=${this.productLink}&i=${imageSrc}`
    },
    desc() {
      if (
        this.product.meta &&
        this.product.meta[`description_${this.$i18n.locale}`]
      ) {
        return this.product.meta[`description_${this.$i18n.locale}`]
      }
      return (
        this.product[`name_${this.$i18n.locale}`] + ' ' + this.$t('descTmpl')
      )
    },
    title() {
      if (
        this.product.meta &&
        this.product.meta[`title_${this.$i18n.locale}`]
      ) {
        return this.product.meta[`description_${this.$i18n.locale}`]
      }
      return (
        this.product[`name_${this.$i18n.locale}`] + ' ' + this.$t('descTmpl')
      )
    },
    productLink() {
      return document.location.href
    },
    productOriginLink() {
      return document.location.origin
    },
    partsPrice() {
      if (this.product.price >= 20000) {
        return Math.round(this.product.price / 24)
      }
      return Math.round(this.product.price / 24)
    },
    productName() {
      return this.product[`name_${this.$i18n.locale}`]
        ? this.product[`name_${this.$i18n.locale}`]
        : this.product.name
        ? this.product.name
        : ''
    },
    productImgSrc() {
      return Array.isArray(this.product.img) && this.product.img.length
        ? `/img${this.product.img[0]}`
        : this.product.img
        ? `/img${this.product.img}`
        : '/img/uploads/error.png'
    },
    productImgSrcSet() {
      // extract missing w from filenames
      return this.product.srcset
        ? this.product.srcset
            .map((v) => {
              let m = v.match(/(\d+)x\d+\.(png|jpg|jpeg|gif)$/i)
              if (m && m.length > 1) {
                return `/img${v} ${m[1]}w`
              } else {
                return `/img${v} 75w`
              }
            })
            .join(',')
        : ''
    },
    productImgSizes() {
      return this.productImgSrcSet ? '(max-width: 540px) 100vw, 540px' : ''
    },
    productImgWidth() {
      if (
        this.product.srcset &&
        this.product.srcset.find((v) => v.match('540x540'))
      ) {
        return 540
      }
      return 410
    },
    productImgHeight() {
      if (
        this.product.srcset &&
        this.product.srcset.find((v) => v.match('580x410'))
      ) {
        return 410
      }
      return 415
    },
    productThumbs() {
      if (Array.isArray(this.product.imgf) && this.product.imgf.length) {
        return this.product.imgf
          .map((img) => (/,/gm.test(img) || !img ? null : `/img${img}`))
          .filter((item) => item)
      } else {
        return []
      }
    },
    productDescription() {
      if (this.product[`description_${this.$i18n.locale}`]) {
        return this.product[`description_${this.$i18n.locale}`]
      } else if (this.product.description) {
        return this.product.description
      } else if (this.product[`exc_${this.$i18n.locale}`]) {
        return this.product[`exc_${this.$i18n.locale}`]
      } else {
        return ''
      }
    },
    statusPercents() {
      const p = +this.product.status
      return p <= 10 ? Math.ceil(p * 10) : p
    },
    statusName() {
      let p = +this.product.status
      if (p > 10) p = p / 10
      if (p >= 8) {
        return this.$t('states.ideal')
      } else if (p >= 5) {
        return this.$t('states.great')
      } else if (p >= 3) {
        return this.$t('states.nice')
      } else {
        return this.$t('states.bad')
      }
    },
    urlShareFB() {
      return `https://www.facebook.com/sharer/sharer.php?display=popup&u=${encodeURIComponent(
        document.location.href
      )}`
    },
    urlShareTwitter() {
      return `https://twitter.com/intent/tweet?text=${encodeURIComponent(
        document.title
      )}&url=${encodeURIComponent(document.location.href)}`
    },
    urlSharePinterest() {
      return `https://pinterest.com/pin/create/button/?url=${encodeURIComponent(
        document.location.href
      )}&description=${encodeURIComponent(
        this.productName
      )}&media=https%3A%2F%2Fapptown.com.ua%2Fwp-content%2Fuploads%2F2019%2F03%2FHTB19LzFjmfD8KJjSszhq6zIJFXaV.jpg`
    },
    categoryAccessories() {
      let cat = this.categories.filter(
        (c) => c.id === this.product.parentCategory
      )
      if (cat && cat[0] && cat[0].children && this.product.filters[0].model) {
        cat = cat[0].children.filter(
          (c) => c.slug === this.product.filters[0].model
        )
        if (cat && cat[0] && cat[0].accessories) {
          return cat[0].accessories
        }
      }
      return []
    },
    accessoriesProducts() {
      if (this.category.accessories && this.category.accessories.length) {
        return this.category.accessories
      } else {
        return this.categoryAccessories
      }
    },
    hasAccessories() {
      return (
        (!!this.category.accessories && this.category.accessories.length) ||
        this.categoryAccessories.length
      )
    },
    hasCrossale() {
      return !!this.category.crossSale && this.category.crossSale.length
    },
    crossaleProducts() {
      return this.category.crossSale || []
    },
    categoryWarranty() {
      let cat = this.categories.filter(
        (c) => c.id === this.product.parentCategory
      )
      if (cat && cat[0] && cat[0].children && this.product.filters[0].model) {
        cat = cat[0].children.filter(
          (c) =>
            c.slug.toLowerCase() === this.product.filters[0].model.toLowerCase()
        )
        if (cat && cat[0] && cat[0].warranty) {
          return cat[0].warranty.filter((w) =>
            this.product.used
              ? w.slug.indexOf('used') === 0
              : w.slug.indexOf('used') === -1
          )
        }
      }
      return []
    },
    // defaultNameWarranty() {
    //   switch (this.$i18n.locale) {
    //     case 'ru':
    //       return `Базовая гарантия ${
    //         this.product.used ? '3 месяца' : '14 дней'
    //       }`
    //     default:
    //       return `Базова гарантія ${this.product.used ? '3 місяця' : '14 днів'}`
    //   }
    // },
    warranties() {
      if (
        Array.isArray(this.category.warranty) &&
        this.category.warranty.length
      ) {
        return this.category.warranty.filter((w) =>
          this.product.used
            ? w.slug.indexOf('used') === 0
            : w.slug.indexOf('used') === -1
        )
      } else {
        return this.categoryWarranty
      }
    },
    hasWarranties() {
      return (
        this.product.stock &&
        // !this.inCart &&
        Array.isArray(this.warranties) &&
        this.warranties.length
      )
    },
    productOptions() {
      const { parentCategory } = this.product
      const parentCategoryOjb = this.categories.find(
        ({ id }) => parentCategory === id
      )
      let categoryFilters = []
      if (parentCategoryOjb) {
        const categoryData = this.filters.find(
          ({ category }) => parentCategoryOjb.slug === category
        )
        if (categoryData) {
          categoryFilters = categoryData.attributes
        }
      }
      const r = {
        memory: [],
        color: [],
        condition: [],
        version: [],
        // used: [],
      }
      if (
        Array.isArray(this.product.options) &&
        this.product.options.length &&
        Array.isArray(this.product.filters) &&
        this.product.filters.length
      ) {
        // find current option
        // const curOpt = this.product.options.find(o => o.slug === this.product.slug)
        let active
        this.product.options.forEach((o) => {
          //console.log(o)
          if (o) {
            if (this.product.used) {
              if (o.used[0] === 'no') {
                return true
              }
            } else {
              if (o.used[0] === 'yes') {
                return true
              }
            }
          }
          if (
            !(
              typeof o.memory === 'object' &&
              o.memory.length &&
              typeof o.color === 'object' &&
              o.color.length
            )
          ) {
            return
          }
          const { color, memory, version, condition } = this.product.filters[0]
          const isVersion = version && o.version
          if (
            !r.memory.find((m) => m.name === o.memory[0]) &&
            color === o.color[0] &&
            condition === o.condition[0]
          ) {
            active = memory === o.memory[0] && o.slug === this.product.slug
            if (!isVersion) {
              r.memory.push({
                name: o.memory[0],
                link: `/product/${this.category.currentPath}/${o.slug}`,
                active,
              })
            } else {
              if (version === o.version[0]) {
                r.memory.push({
                  name: o.memory[0],
                  link: `/product/${this.category.currentPath}/${o.slug}`,
                  active,
                })
              }
            }
          }
          if (
            version &&
            !r.version.find((m) => m.name === o.version[0]) &&
            color === o.color[0] &&
            memory === o.memory[0] &&
            version === o.version[0]
          ) {
            active = version === o.version[0] && o.slug === this.product.slug
            r.version.push({
              name: o.version[0],
              link: `/product/${this.category.currentPath}/${o.slug}`,
              active,
            })
          }
          if (
            !r.color.find((c) => c.name === o.color[0]) &&
            memory === o.memory[0] &&
            condition === o.condition[0]
          ) {
            active = color === o.color[0] && o.slug === this.product.slug
            if (!isVersion) {
              r.color.push({
                name: o.color[0],
                link: `/product/${this.category.currentPath}/${o.slug}`,
                active,
              })
            } else {
              if (version === o.version[0]) {
                r.color.push({
                  name: o.color[0],
                  link: `/product/${this.category.currentPath}/${o.slug}`,
                  active,
                })
              }
            }
          }
          if (
            condition &&
            !r.condition.find((c) => c.name === o.condition[0]) &&
            memory === o.memory[0] &&
            color === o.color[0]
          ) {
            active =
              condition === o.condition[0] && o.slug === this.product.slug
            let name = o.condition[0]
            const conditionsData = categoryFilters.find(
              ({ slug }) => slug === 'condition'
            )
            if (conditionsData) {
              const optionData = (conditionsData.options || []).find(
                ({ slug }) => slug === name
              )
              if (optionData) {
                name = optionData[`name_${this.$i18n.locale}`]
              }
            }
            if (!isVersion) {
              r.condition.push({
                name,
                link: `/product/${this.category.currentPath}/${o.slug}`,
                active,
              })
            } else {
              if (version === o.version[0]) {
                r.color.push({
                  name,
                  link: `/product/${this.category.currentPath}/${o.slug}`,
                  active,
                })
              }
            }
          }
        })
        const memoryCompare = (a, b) => {
          let aVal = parseInt(a.name)
          if (isNaN(aVal)) aVal = 0
          let bVal = parseInt(b.name)
          if (isNaN(bVal)) bVal = 0
          if (aVal < bVal) {
            return -1
          }
          if (aVal > bVal) {
            return 1
          }
          return 0
        }
        r.memory.sort(memoryCompare)
      }
      // console.log('*[productOptions]', r)
      r.condition.reverse()
      return r
    },
    hasOptions() {
      const opts = this.productOptions
      return (
        opts &&
        (opts.memory.length || opts.color.length || opts.condition.length)
      ) // || opts.used.length
    },
    hasProfitable() {
      return (
        Array.isArray(this.product.profitableKit) &&
        this.product.profitableKit.length
      )
    },
    inCart() {
      return !!this.cart.items.find((item) => item.id === this.product._id)
    },
    ...mapState([
      'breadcrumbs',
      'cart',
      'category',
      'options',
      'product',
      'categories',
      'filters',
    ]),
  },
  methods: {
    getRandomNumber(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min)
    },
    getSize(key) {
      const [sizeStr, id] = key.match(/[a-zA-Z]+|[0-9]+/g)
      let size = Number(sizeStr)
      switch (id) {
        case 'tb':
          size = size * 1000
          break
        case 'mb':
          size = size / 1000
          break
        default:
          break
      }
      return size
    },
    sortMemories(list) {
      const sortedList = list.sort(
        (a, b) => this.getSize(a.name) - this.getSize(b.name)
      )
      return sortedList
    },
    scroll() {
      this.$refs.tab_scroll.scrollTo()
    },
    isPaymentEnabled(v) {
      let id = `${v}`.toLowerCase()
      return !!this.$store?.state?.payments?.[id]
    },
    openDeliveryModal() {
      this.deliveryModal = true
    },
    togglePayPartsModal() {
      this.payParts.modal = !this.payParts.modal
    },
    nameWarranty(warranty) {
      return warranty[`name_${this.$i18n.locale}`] || warranty.name || ''
    },
    onGallery() {
      this.setGalleryModal(0)
    },
    onGallerySlide(n) {
      this.setGalleryModal(0)
      this.setGalleryModal(n)
    },
    onAddToCart() {
      let item = {}
      console.log('this.selectedWarranties', this.selectedWarranties)
      Object.assign(
        item,
        this.product,
        { warranty: this.selectedWarranties },
        { single: true }
      )
      let path = this.$route.params.pathMatch
      this.$store.dispatch('fetchProduct', path).then(() => {
        // console.log('*[PRODUCT]', this.product)
        // console.log('*[CATEGORY]', this.category)
        let breadcrumbs = []
        let categoryPath = '/product-category'
        let chain = this.$h.parsePath(path)
        if (chain.length > 2) {
          chain.pop()
          let c = null // product category
          let _c = this.$store.state.categories // iteration parent
          chain.forEach((p, i) => {
            c = _c.find((c) => c.slug === p)
            if (c) {
              _c = c.children
              categoryPath += `/${p}`
              breadcrumbs.push({
                i,
                to: categoryPath,
                name: c[`name_${this.$i18n.locale}`],
              })
            } else {
              c = null
            }
          })
        }
        let variant = ''
        let p = this.product
        if (p['filters']) {
          if (p['filters'][0]['color']) {
            variant = p['filters'][0]['color']
          }
          if (variant && p['filters'][0]['memory']) {
            variant = variant + ' ' + p['filters'][0]['memory']
          }
        }
        let listcat_full = breadcrumbs
          .map(function (elem) {
            return elem['name']
          })
          .join('/')

        this.$h.gtmDataLayerPush({
          ecomm_pagetype: 'cart',
          ecomm_prodid: p['id'],
          ecomm_totalvalue: p['newPrice'] ? p['newPrice'] : p['price'],
        })

        const item_list_id = uuidv4()
        this.$gtag.event('add_to_cart', {
          items: [
            {
              item_name: p[`name_${this.$i18n.locale}`],
              item_id: p['id'],
              price: p['newPrice'] ? p['newPrice'] : p['price'],
              currency: 'UAH',
              item_brand: 'Apple',
              item_category: listcat_full,
              item_list_name: 'Product page',
              item_list_id,
              index: 0,
              quantity: 1,
            },
          ],
        })
      })
      this.addToCart(item)
        .then(() => {
          console.log('*ADDED')
        })
        .catch((e) => {
          console.log('*ERROR', e)
        })
    },
    onWarrantyChange() {
      let item = this.cart.items.find((item) => item.id === this.product._id)
      if (item && !item.warranty.length) {
        Object.assign(item, { warranty: this.selectedWarranties })
        this.addWarranty(item)
      }
    },
    onPayParts() {
      let item = {}
      Object.assign(
        item,
        this.product,
        { warranty: this.selectedWarranties },
        { single: true }
      )

      let path = this.$route.params.pathMatch
      this.$store.dispatch('fetchProduct', path).then(() => {
        // console.log('*[PRODUCT]', this.product)
        // console.log('*[CATEGORY]', this.category)
        let breadcrumbs = []
        let categoryPath = '/product-category'
        let chain = this.$h.parsePath(path)
        if (chain.length > 2) {
          chain.pop()
          let c = null // product category
          let _c = this.$store.state.categories // iteration parent
          chain.forEach((p, i) => {
            c = _c.find((c) => c.slug === p)
            if (c) {
              _c = c.children
              categoryPath += `/${p}`
              breadcrumbs.push({
                i,
                to: categoryPath,
                name: c[`name_${this.$i18n.locale}`],
              })
            } else {
              c = null
            }
          })
        }
        let variant = ''
        let p = this.product
        if (p['filters']) {
          if (p['filters'][0]['color']) {
            variant = p['filters'][0]['color']
          }
          if (variant && p['filters'][0]['memory']) {
            variant = variant + ' ' + p['filters'][0]['memory']
          }
        }
        let listcat_full = breadcrumbs
          .map(function (elem) {
            return elem['name']
          })
          .join('/')

        this.$h.gtmDataLayerPush({
          ecomm_pagetype: 'cart',
          ecomm_prodid: p['id'],
          ecomm_totalvalue: p['newPrice'] ? p['newPrice'] : p['price'],
        })

        const item_list_id = uuidv4()
        this.$gtag.event('add_to_cart', {
          items: [
            {
              item_name: p[`name_${this.$i18n.locale}`],
              item_id: p['id'],
              price: p['newPrice'] ? p['newPrice'] : p['price'],
              currency: 'UAH',
              item_brand: 'Apple',
              item_category: listcat_full,
              item_list_name: 'Product page',
              item_list_id,
              index: 0,
              quantity: 1,
            },
          ],
        })
      })
      this.addToCart(item)
        .then(() => {
          this.$router.push(
            `/checkout?partsCount=${this.payParts.count}&paymentMethod=${this.paymentMethod}`
          )
        })
        .catch(() => {
          console.log('*ERROR')
        })
    },
    onQuickOrder() {
      this.$store.commit('setProductModal', this.product)
      this.setQuickOrderModal(true)
    },
    onPreOrder() {
      this.$store.commit('setProductModal', this.product)
      this.setPreOrderModal(true)
    },
    onNotifyOnStock() {
      this.$store.commit('setProductModal', this.product)
      this.setNotifyStockModal(true)
    },
    onDeliveryModal() {
      this.setDeliveryModal(true)
    },
    onSwitchTab(tab) {
      this.currentTab = tab
    },
    onSetRating(v, event) {
      const ratings = document.querySelectorAll('.stars span a')
      const { target } = event
      ratings.forEach((el) => {
        el.classList.remove('active')
      })
      target.classList.add('active')
      this.feedbackRating = v
    },
    onSubmitReview() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      } else {
        const review = {
          created: Date.now(),
          name: this.feedbackName,
          email: this.feedbackEmail,
          content: this.feedbackComment,
          rating: this.feedbackRating,
          product: this.product.id,
        }
        this.submitReview(review)
          .then(() => {
            this.$v.$reset()
            this.sent = true
            this.feedbackName = ''
            this.feedbackComment = ''
            this.feedbackEmail = ''
            this.feedbackRating = 0
            console.log('*OK')
          })
          .catch(() => {
            console.log('*NOT SUBMITTED')
          })
      }
    },
    initProduct() {
      const _this = this
      this.loading = true
      let path = this.$route.params.pathMatch
      // todo: filter out /page/n cases
      this.$store.commit('setProduct', { warranty: [] })
      this.$store
        .dispatch('fetchProduct', path)
        .then(() => {
          // console.log('*[PRODUCT]', this.product)
          // console.log('*[CATEGORY]', this.category)
          let breadcrumbs = []
          let categoryPath = '/product-category'
          let chain = this.$h.parsePath(path)
          if (chain.length > 2) {
            chain.pop()
            let category = {}
            let pc = null // parent 2-nd level category
            let c = null // product category
            let _c = this.$store.state.categories // iteration parent
            chain.forEach((p, i) => {
              c = _c.find((c) => c.slug === p)
              if (c) {
                _c = c.children
                if (i === 1) {
                  pc = c
                }
                categoryPath += `/${p}`
                breadcrumbs.push({
                  i,
                  to: categoryPath,
                  name: c[`name_${this.$i18n.locale}`],
                })
              } else {
                c = null
              }
            })
            // console.log('*[pc]', pc)
            // console.log('*[c]', c)
            if (c && pc) {
              Object.assign(category, c, {
                currentPath: chain.join('/'),
                warranty: pc.warranty,
                crossSale: pc.crossSale,
                accessories: pc.accessories,
              })
              this.setCategory(category)
            }
          }
          const name = this.productName
          breadcrumbs.push({ name })
          this.setHeadline(name)
          this.setBreadcrumbs(breadcrumbs)
          //this.$forceUpdate()
          this.loading = false
          //console.log(this.category['page'])
          let variant = ''
          let p = this.product
          console.log('p', p)
          if (p['filters']) {
            if (p['filters'][0]['color']) {
              variant = p['filters'][0]['color']
            }
            if (variant && p['filters'][0]['memory']) {
              variant = variant + ' ' + p['filters'][0]['memory']
            }
          }
          let listcat_full = breadcrumbs
            .map(function (elem) {
              return elem['name']
            })
            .join('/')

          this.$h.gtmDataLayerPush({
            ecomm_pagetype: 'product',
            ecomm_prodid: p.id,
            ecomm_totalvalue: p['newPrice'] ? p['newPrice'] : p['price'],
          })
          //console.log(item_et)
          const item_list_id = uuidv4()
          this.$gtag.event('view_item', {
            items: [
              {
                item_name: p[`name_${this.$i18n.locale}`],
                item_id: p['id'],
                price: p['newPrice'] ? p['newPrice'] : p['price'],
                currency: 'UAH',
                item_brand: 'Apple',
                item_category: listcat_full,
                item_list_name: 'Product page',
                item_list_id,
                quantity: 1,
              },
            ],
          })
        })
        .catch((err) => {
          _this.loading = false
          // _this.status = true
          console.log('*[PRODUCT FETCH ERROR]', err)
        })
    },
    colorClassName(name) {
      return 'color-' + name.replace(' ', '')
    },
    formatFloat(v) {
      let r = new String(v)
      return r.match(/^\d+\.\d+$/) ? r : `${r}.0`
    },
    triggerProdOptionClick(selector) {
      const element = document.querySelector(selector)
      if (element) {
        if (!element.checked) {
          element.click()
        }
        element.disabled = true
      }
    },
    async onPayPartsCountChange(newPayPartsCount) {
      const { used, parentCategory } = this.product
      const category = this.categories.find(({ id }) => id === parentCategory)
      const elements = document.querySelectorAll('[data-prod-option-id]')

      this.selectedWarranties = []
      await this.onWarrantyChange()

      if (elements && elements.length) {
        elements.forEach((element) => {
          element.disabled = false
        })
      }

      if (this.paymentMethod === 'Mono') {
        const triggerAppleAirpods = () => {
          if (used) {
            this.triggerProdOptionClick('[data-name="Гарантія 1 Рік"]')
          } else {
            this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
          }
        }
        const triggerAppleWatch = () => {
          if (!used) {
            if (
              [
                'apple-watch-series-9',
                'apple-watch-series-8',
                'apple-watch-series-7',
                'apple-watch-series-6',
                'apple-watch-se-2',
              ].includes(this.category.slug)
            ) {
              this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
            } else if (
              ['apple-watch-ultra-2', 'apple-watch-ultra'].includes(
                this.category.slug
              )
            ) {
              this.triggerProdOptionClick('[data-name="Starter Kit"]')
            }
          } else {
            if (
              [
                'apple-watch-series-3',
                'apple-watch-series-4',
                'apple-watch-series-5',
                'apple-watch-series-6',
                'apple-watch-series-7',
              ].includes(this.category.slug)
            ) {
              this.triggerProdOptionClick('[data-name="Гарантія 1 Рік"]')
            } else if (this.category.slug === 'apple-watch-series-8') {
              this.triggerProdOptionClick('[data-name="Гарантія 1 Рік"]')
              this.triggerProdOptionClick('[data-name="Адаптер живлення 20w"]')
            }
          }
        }
        if (newPayPartsCount === 6) {
          if (category?.slug === 'iphone') {
            if (used) {
              if (
                /11/gm.test(this.category.slug) ||
                this.category.slug === 'iphone-12'
              ) {
                this.triggerProdOptionClick('[data-name="Гарантія 1 Рік"]')
              } else if (['iphone-13'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
              } else if (['iphone-12-pro'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Гарантія 1 Рік"]')
              } else if (
                ['iphone-13', 'iphone-13-pro'].includes(this.category.slug)
              ) {
                this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
              } else if (['iphone-13-pro-max'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Гарантія 1 Рік"]')
                this.triggerProdOptionClick(
                  '[data-name="Повний комплект для б/у iPhone"]'
                )
              } else if (['iphone-14'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
              } else if (/13|14|15/gm.test(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Starter Kit"]')
              } else if (/16/gm.test(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Starter Kit"]')
                if (
                  ['iphone-16-pro', 'iphone-16-pro-max'].includes(
                    this.category.slug
                  )
                ) {
                  this.triggerProdOptionClick(
                    '[data-name="Комплект швидкої зарядки"]'
                  )
                }
              }
            } else {
              if (
                !['iphone-13', 'iphone-14', 'iphone-16'].includes(
                  this.category.slug
                )
              ) {
                this.triggerProdOptionClick('[data-name="Starter Kit"]')
              }

              if (['iphone-13'].includes(this.category.slug)) {
                this.triggerProdOptionClick(
                  '[data-name="Захист дисплею та корпусу"]'
                )
              } else if (
                [
                  'iphone-14',
                  'iphone-15-pro-max',
                  'iphone-16',
                  'iphone-16-pro-max',
                ].includes(this.category.slug)
              ) {
                this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
              }
            }
          } else if (category?.slug === 'apple-airpods') {
            triggerAppleAirpods()
          } else if (category?.slug === 'apple-watch') {
            triggerAppleWatch()
            if (used) {
              if (this.category.slug === 'apple-watch-ultra') {
                this.triggerProdOptionClick('[data-name="Гарантія 1 Рік"]')
                this.triggerProdOptionClick(
                  '[data-name="Адаптер живлення 20w"]'
                )
              }
            }
          }
        } else if (newPayPartsCount === 9) {
          if (category?.slug === 'iphone') {
            if (used) {
              if (
                ![
                  'iphone-11',
                  'iphone-11-pro-max',
                  'iphone-12',
                  'iphone-12-pro',
                  'iphone-12-pro-max',
                  'iphone-13',
                  'iphone-13-pro',
                  'iphone-13-pro-max',
                  'iphone-14',
                  'iphone-14-pro',
                  'iphone-14-pro-max',
                  'iphone-15',
                  'iphone-15-pro',
                  'iphone-15-pro-max',
                  'iphone-16',
                  'iphone-16-pro',
                  'iphone-16-pro-max',
                ].includes(this.category.slug)
              ) {
                this.triggerProdOptionClick(
                  '[data-name="Захист дисплею та корпусу"]'
                )
              }
              if (['iphone-11'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Гарантія 1 Рік"]')
              } else if (['iphone-11-pro-max'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
              } else if (
                ['iphone-12', 'iphone-12-pro', 'iphone-12-pro-max'].includes(
                  this.category.slug
                )
              ) {
                this.triggerProdOptionClick('[data-name="Гарантія 1 Рік"]')
                this.triggerProdOptionClick(
                  '[data-name="Повний комплект для б/у iPhone"]'
                )
              } else if (['iphone-13'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
              } else if (['iphone-13-pro'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
                this.triggerProdOptionClick(
                  '[data-name="Повний комплект для б/у iPhone"]'
                )
              } else if (['iphone-13-pro-max'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Гарантія 1 Рік"]')
                this.triggerProdOptionClick(
                  '[data-name="Повний комплект для б/у iPhone"]'
                )
              } else if (['iphone-14'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Гарантія 1 Рік"]')
                this.triggerProdOptionClick(
                  '[data-name="Комплект швидкої зарядки"]'
                )
              } else if (
                ['iphone-14-pro', 'iphone-14-pro-max', 'iphone-15'].includes(
                  this.category.slug
                )
              ) {
                this.triggerProdOptionClick('[data-name="Starter Kit"]')
              } else if (
                ['iphone-15-pro', 'iphone-15-pro-max'].includes(
                  this.category.slug
                )
              ) {
                this.triggerProdOptionClick('[data-name="Starter Kit"]')
                this.triggerProdOptionClick(
                  '[data-name="Адаптер живлення 20w "]'
                )
              } else if (/16/gm.test(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Starter Kit"]')
                this.triggerProdOptionClick(
                  '[data-name="Комплект швидкої зарядки"]'
                )
                if (
                  ['iphone-16-pro', 'iphone-16-pro-max'].includes(
                    this.category.slug
                  )
                ) {
                  this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
                }
              }
            } else {
              if (
                ![
                  'iphone-14',
                  'iphone-15',
                  'iphone-15-plus',
                  'iphone-15-pro',
                  'iphone-16',
                  'iphone-16-plus',
                  'iphone-16-pro',
                  'iphone-16-pro-max',
                  'iphone-16e',
                ].includes(this.category.slug)
              ) {
                this.triggerProdOptionClick(
                  '[data-name="Захист дисплею та корпусу"]'
                )
              }
              if (['iphone-14'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
              } else if (
                ['iphone-15', 'iphone-15-plus'].includes(this.category.slug)
              ) {
                this.triggerProdOptionClick('[data-name="Starter Kit"]')
              } else if (['iphone-15-pro'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Starter Kit"]')
                this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
              } else if (['iphone-16'].includes(this.category.slug)) {
                this.triggerProdOptionClick(
                  '[data-name="Адаптер живлення 20w "]'
                )
                this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
              } else if (
                ['iphone-16-plus', 'iphone-16-pro'].includes(this.category.slug)
              ) {
                this.triggerProdOptionClick('[data-name="Starter Kit"]')
                this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
              } else if (['iphone-16-pro-max'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Starter Kit"]')
                this.triggerProdOptionClick('[data-name="Гарантія 2 Роки"]')
                this.triggerProdOptionClick(
                  '[data-name="Адаптер живлення 20w "]'
                )
              } else if (['iphone-16e'].includes(this.category.slug)) {
                this.triggerProdOptionClick('[data-name="Starter Kit"]')
              }
            }
          } else if (category?.slug === 'apple-airpods') {
            triggerAppleAirpods()
          } else if (category?.slug === 'apple-watch') {
            triggerAppleWatch()
            if (used) {
              if (this.category.slug === 'apple-watch-ultra') {
                this.triggerProdOptionClick('[data-name="Гарантія 1 Рік"]')
                this.triggerProdOptionClick('[data-name="Starter Kit"]')
              }
            }
          }
        }
      }
    },
    ...mapMutations([
      'setQuickOrderModal',
      'setPreOrderModal',
      'setNotifyStockModal',
      'setDeliveryModal',
      'setCategory',
      'setGalleryModal',
      'resetProduct',
      'setBreadcrumbs',
      'addWarranty',
    ]),
    ...mapActions([
      'fetchProduct',
      'fetchCategory',
      'addToCart',
      'submitReview',
      'setHeadline',
    ]),
  },
  mixins: [validationMixin, PayPartsMixin, GlobusMixin],
  validations: {
    feedbackName: {
      required,
    },
    feedbackComment: {
      required,
    },
    feedbackEmail: {
      required,
      alpha: helpers.regex(
        'alpha',
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      ),
    },
  },
  beforeMount() {
    this.initProduct()
    this.lang = this.$store.getters.lang

    if (
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      )
    ) {
      this.garantyMobile = true
    } else {
      this.garantyMobile = false
    }
  },
  mounted() {
    document.body.classList.add('product-page')
  },
  unmount() {
    this.resetProduct()
  },
  destroyed() {
    document.body.classList.remove('product-page')
  },
  watch: {
    async loading(newValue) {
      if (
        !newValue &&
        this.paymentMethod === 'Mono' &&
        this.selectedWarranties.length
      ) {
        await this.onPayPartsCountChange(this.payParts.count)
      }
    },
    '$route.params.pathMatch': async function (pathMatch) {
      console.log('*watch[pathMatch]', pathMatch)
      this.initProduct()
    },
    paymentMethod(newPaymentMethod) {
      if (newPaymentMethod === 'Globus') {
        this.payParts.count = 4
      } else {
        this.payParts.count = 3
      }

      if (newPaymentMethod !== 'Mono') {
        this.selectedWarranties = []
        this.onWarrantyChange()
      }
    },
    'payParts.count': async function (newPayPartsCount) {
      await this.onPayPartsCountChange(newPayPartsCount)
    },
  },
  updated() {
    this.lang = this.$store.getters.lang
  },
}
</script>

<style>
@import '~@/assets/css/colors.css';

.dt-block1 {
  color: #888;
  letter-spacing: 0.25px;
  margin: 0;
  border: 0;
  vertical-align: baseline;
  outline: 0;
  padding: 20px 0;
  position: relative;
}
.used-items-title {
  margin-bottom: 10px;
}
.used-items-bar {
  background-color: #a9a9a9;
  border: 1px solid #a9a9a9;
  border-radius: 10px;
}
.used-items-bar-active {
  background-image: linear-gradient(
    to left,
    #6ec66f,
    #93c66e,
    #b2c66e,
    #c6b76e,
    #d75e5e
  );
  color: #fff;
  font-size: 15px;
  font-weight: 700;
  padding: 4px 0;
  text-align: right;
  padding-right: 10px;
  box-sizing: border-box;
  border-radius: 10px;
}
.used-items-names {
  font-size: 12px;
  color: #b2b2b2;
  margin-top: -4px;
  display: flex;
}
.used-items-names span {
  width: 25%;
  display: inline-block;
  text-align: center;
  border-right: 1px solid #a9a9a9;
  box-sizing: border-box;
  padding: 7px 0;
}
.cart-prod-opt-item {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.cart-prod-options input[type='checkbox'],
.cart-prod-options input[type='radio'] {
  display: none;
  visibility: hidden;
}
.cart-prod-options {
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-orient: vertical;
  -webkit-box-direction: normal;
  -webkit-flex-direction: column;
  -ms-flex-direction: column;
  flex-direction: column;
  width: 100%;
  margin-top: 5px;
}
.cart-prod-options label,
.cart-prod-options .cart-opt-sum-item {
  /* font-family: 'Proxima Nova Regular'; */
  font-family: 'Nunito', sans-serif;
  font-size: 15px;
  line-height: 1.2;
  margin-bottom: 6px;
}
.cart-prod-options input[type='checkbox'] + label:hover {
  color: #333;
}
.cart-prod-options input[type='checkbox'] + label:before {
  content: '';
  display: block;
  position: absolute;
  width: 18px;
  height: 16px;
  border: 1px solid #a9a9a9;
  left: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
}
.cart-prod-options input[type='checkbox'] + label:before {
  border-radius: 8px;
  content: '';
  height: 14px;
  position: absolute;
  transition: all 0.4s ease-in-out;
  width: 28px;
  border: 1px solid #a9a9a9;
  background: #a9a9a9;
}
.cart-prod-options input[type='checkbox'] + label:after {
  background: #fff;
  border-radius: 16px;
  content: '';
  height: 14px;
  border: 1px solid #a9a9a9;
  position: absolute;
  transition: all 0.3s ease-in-out;
  width: 14px;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
}
.cart-prod-options input[type='checkbox'] + label {
  position: relative;
  color: #666;
  position: relative;
  padding-left: 35px;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  font-weight: 400;
}
.cart-prod-options input[type='checkbox']:checked + label {
  font-weight: 600;
  padding-left: 35px;
  /* font-family: 'Proxima Nova Regular'; */
  font-family: 'Nunito', sans-serif;
  color: #666;
}
.cart-prod-options input[type='checkbox']:checked + label .cart-opt-sum-item {
  font-weight: 600;
  color: #666;
}
.cart-prod-options input[type='checkbox']:checked span {
  color: #666;
}
.cart-prod-options input[type='checkbox']:checked + label:before {
  background: #fff;
  border: 1px solid #666;
}
.cart-prod-options input[type='checkbox']:checked + label:after {
  background: #000;
  left: 14px;
  border: 1px solid #666;
}
.cart-prod-opt-item {
  -webkit-box-pack: justify;
  -webkit-justify-content: space-between;
  -ms-flex-pack: justify;
  justify-content: space-between;
  display: -webkit-box;
  display: -webkit-flex;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -webkit-align-items: center;
  -ms-flex-align: center;
  align-items: center;
}
.cart-prod-options input[type='checkbox'] + label {
  position: relative;
  cursor: pointer;
  -webkit-transition: 0.3s;
  transition: 0.3s;
  font-weight: 400;
  line-height: 25px;
  cursor: pointer;
  /* font-family: 'Proxima Nova Regular'; */
  font-family: 'Nunito', sans-serif;
  font-size: 15px;
  white-space: nowrap;
  display: inline-flex;
  justify-content: space-between;
  flex: 0 0 100%;
  align-items: center;
  letter-spacing: 0.1px;
}
.cart-prod-opt-item.m-default input[type='checkbox'] + label {
  white-space: normal;
}
.cart-prod-options label,
.cart-prod-options .cart-opt-sum-item {
  /* font-family: 'Proxima Nova Regular'; */
  font-family: 'Nunito', sans-serif;
  font-size: 15px;
  line-height: 1.2;
  margin-bottom: 0;
  font-weight: 400;
  line-height: 25px;
}
.product-crosslinks hr {
  margin: 20px 0 !important;
}
.product-description {
  font-size: 18px !important;
  color: #333 !important;
}
.option-title {
  padding-bottom: 10px;
}
.memory-options {
  flex-wrap: wrap;
  flex-direction: row;
  display: flex;
}
.memory-options a {
  margin-right: 8px;
  border: 1px solid #999999;
  color: #999999;
  border-radius: 4px;
  transition: 0.3s;
  display: flex;
  padding: 3px 8px;
  min-height: 26px;
  align-items: center;
  justify-content: center;
  /* font-family: 'Proxima Nova Regular'; */
  font-family: 'Nunito', sans-serif;
  font-size: 16px;
}
.memory-options a:hover {
  border: 1px solid rgba(255, 150, 0, 0.9);
  color: #fff;
  background: rgba(255, 150, 0, 0.9);
}
.memory-options a.act {
  background: rgba(255, 150, 0, 0.9);
  color: #444444;
}
.memory-options a.act:hover {
  background: none;
  color: #999999;
}
.color-options {
  vertical-align: middle;
  padding: 0 10px;
}
.item-color {
  width: 32px;
  height: 32px;
  margin-bottom: 5px;
  -webkit-border-radius: 50%;
  border: 1px solid #999999;
  border-radius: 50%;
  display: inline-block;
  margin-right: 20px;
  margin-top: 0;
  position: relative;
  cursor: pointer;
}
.item-color.act:before,
.item-color:hover:before {
  border: 2px solid #999999;
  content: '';
  position: absolute;
  width: calc(100% + 8px);
  height: calc(100% + 8px);
  border-radius: 50%;
  top: -4px;
  left: -4px;
  transition: 0.3s;
}
.delivery {
  text-decoration: underline;
  font-size: 20px;
  cursor: pointer;
  margin-top: 40px;
  text-align: center;
}
.error {
  color: red;
  /* margin-top: -10px; */
  overflow: unset;
}
/* .payParts::after {
  content: '';
  background-image: url(/img/proof-7.png);
  background-repeat: no-repeat;
  background-size: cover;
  position: absolute;
  top: 0;
  left: 0;
  height: 240px;
  width: 50px;
} */
.price {
  position: relative;
}
.garanty-info {
  margin-top: 10px;
  display: flex;
}
.garanty-info img {
  height: 25px;
}
.garanty-info span {
  margin-top: 20px;
  margin-left: 10px;
}
.garanty-info span p {
  font-size: 14px;
  line-height: 20px;
  margin-top: -15px;
}

.garanty-info-mobile {
  height: 110px;
  margin-top: 20px;
  display: flex;
  justify-content: center;
}
.garanty-info-mobile img {
  height: 25px;
}
.garanty-info-mobile span {
  margin-top: 20px;
  margin-left: 10px;
}
.garanty-info-mobile span p {
  font-size: 12px;
  line-height: 15px;
  margin-top: -15px;
}

.pay_parts_block {
  margin-top: 20px;
}

@media only screen and (max-width: 500px) {
  .delivery-block {
    margin-top: 0;
  }
  .pay_parts_block .button.buy-parts-product {
    width: 300px;
  }
}

.slonCredit-iframe-wrapper {
  height: 400px;
}
</style>
